import axios from 'axios'
import md5 from 'md5'
import { Toast } from 'vant'
import store from '../store/index'
import { _getUserInfo,_setToken } from '../store/localStorage'
// 国内
// var httpUrl = 'https://localdebug.wandian.net.cn'//本地
// var httpUrl = 'https://testdebug.wandian.net.cn'//测试
// var httpUrl = 'https://api.wandian.net.cn'//线上
// 海外
// var httpUrl = 'https://test5.wonder.net.cn'//本地
var httpUrl = 'https://apitest.coinwoned.com'//测试
// var httpUrl = 'https://apicoinwoned.daylong.net.cn'//线上

//var httpUrl = 'apitest', /*本地代理*/
const service = axios.create({
  timeout: 5000 // request timeout时间
})
var tokenObj = store.state.token
/**
 * post 请求加密
 * @param {DateTime} timestamp 时间戳
 * @param {Object} data 上传的参数
 */
function encode(timestamp,data){
  var key = 'daylong@168.'
  var platform = 'web'
  return {
    timestamp:timestamp,
    platform:platform,
    daylongPas:md5(timestamp+"+"+key+"+"+JSON.stringify(data)+"+"+platform)
  }
}

service.interceptors.request.use(
  request => {
    if(request.method==='get'){
      //时间戳
      if(request.url.split('?').length>1)
        request.url+='&date='+new Date().getTime()
      else
        request.url+='?date='+new Date().getTime()
      //token
      if( (request.url.indexOf('?userId=') || request.url.indexOf('&userId=') ) && tokenObj.accessToken){
        request.url+=("&accessToken="+tokenObj.accessToken)
      }
    }else if (request.method === 'post'){
      //接口参数冲突，如果是vivo渠道码接口，则不添加渠道码参数
      if( ! request.url.includes('/peripheral/activity_cdkey_recharge')){
        request.data.channelCode='offical'
      }
      //token
      if( (request.data.userId ) && tokenObj.accessToken){
        request.data.accessToken=tokenObj.accessToken
      }
      request.data.version = '1.0.0'
      request.headers = encode(new Date().getTime(), request.data)
      // console.info(encode(new Date().getTime(), request.data) ,request.data)
    }
      request.url = httpUrl + request.url;//
    return request;
  }
)
const excludeUrlList = ['/front/peripheral/activity_cdkey_recharge','/login/login/token_login']
service.interceptors.response.use(
  response => {
    var resule = response.data
    //排除掉无需处理的接口
    if(excludeUrlList.includes(response.config.url))
      return resule
    //token过期,则刷新token
    if(1210 == resule.status){
      if(response.config.url.indexOf('/login/token_refresh')>-1){
        store.dispatch('logout')
        if(location.href.includes('/game')){
          location.href = '#/game/login?redirect='+encodeURIComponent(response.config.url)
        }else{
          location.href = '/'
        }
        Toast('登录超时')
        return
      }else
        queryNewToken()
    }
    if( ![1,1024,1210].includes(resule.status)){
      if(resule.status==undefined&&response.status==200){
        return resule
      }
      console.info(resule.errorMsg)
      Toast({message:resule.errorMsg})
    }
    return resule
  }
)
function queryNewToken(){
  var nowTime = Date.now()
  if( tokenObj.loginTime+tokenObj.refreshOutTime > nowTime ){
    service.post('/login/login/token_refresh',{
        "accessToken":tokenObj.accessToken,
        "refreshToken":tokenObj.refreshToken
    }).then(( {data:{accessToken,accessOutTime,refreshToken,refreshOutTime},status,errorMsg} )=>{
          if(status==1){
            store.commit('setUserInfo',{
                userMsg:_getUserInfo(),
                accessToken:accessToken,
                accessOutTime:accessOutTime,
                refreshToken:refreshToken,
                refreshOutTime:refreshOutTime,
                loginTime:Date.now()
            })
          }else{
            Toast(errorMsg)
          }
      }).catch((error)=>{
          console.info(error)
      })
  }else{
    store.dispatch('logout')
    if(location.href.includes('/game')){
      location.href = '#/game/login?redirect='+encodeURIComponent(window.location.href)
    }else{
      location.href = '/'
    }
  }
}
export default service
